import {getAcceptLanguage, salesqueze} from "~/plugins/salesqueze-sdk-browser";
import {getCartFromLocalStorage} from "~/utils/cart-util";
import {getFormFromLocalStorage} from "~/utils/form-util";
import { getProducts } from "~/utils/products-util";
import { getPartner } from "~/utils/partners-util";

export const state = () => ({
    products: [],
    /**
     * { key: string, webLogo: string, webLogoWhite: string }
     */
    partner: {},
    cartItems: getCartFromLocalStorage(),
    formData: getFormFromLocalStorage(),
    configuration: {},
    editingIndex: null
})
export const getters = {
    /*
      return items from store
    */
    getProducts: (state) => state.products,
    getPartner: (state) => state.partner,
    getCartItems: (state) => state.cartItems,
    getConfiguration: (state) => state.configuration,
    // getCart: (state) => state.cartItems,
    getCartTotal: (state) =>
        state.cartItems.length < 1
            ? '0'
            : state.cartItems
                .map((el) => el.price * el.quantity)
                .reduce((a, b) => a + b),
    getEditingIndex: (state) => state.editingIndex
}
export const actions = {
    async addItemToCart({commit}, data) {
        await commit('setCartItem', data)
    },
    async addItemToForm({commit}, item) {
        await commit('setFormItem', item)
    },
    async updateCart({commit}, cart) {
        await commit('setCart', cart)
    },
    async addConfiguration({commit}, configuration) {
        await commit('setConfiguration', configuration)
    },
    async deleteCartItem({commit}, idx) {
        await commit('removeCartItem', idx)
    },
    async deleteCart({commit}) {
        await commit('removeCart')
    },
    async deleteForm({commit}) {
        await commit('removeForm')
    },
    async deleteConfiguration({commit}) {
        await commit('removeConfiguration')
    },
    async submitCart({commit, state}, submitData) {
      const cart = getCartFromLocalStorage();
      const localForm = getFormFromLocalStorage();
      const keys = Object.keys(localForm || {}) || [];
      const form = {};

      // try catch needs to be around, otherwise there's some random error. with try catch there is no error.
      try {
        keys.map((key) => {
          const x = localForm[key];
          form[x.key] = x.config.config;
        })
      } catch (e) {
      }

      form.questions = (cart || []).map((x) => {
        // form[x.key] = x.config.config
        const obj = {
          ...x.config.config,
          key: x.key,
          subKey: x.subKey,
        }
        return obj;
      })
      form.country = submitData.countryText;
      form.privacy = submitData.privacy;

      const body = {
        // crm: {
        //     contact: submitData.customer
        // }
        metaFields: {
            partner_key: state.partner && state.partner.key
        },
        metadata: {
            tags: [{ title: getAcceptLanguage() }],
            language: getAcceptLanguage()
        },
        cpq: {
            name: `${submitData.customer.firstName} ${submitData.customer.lastName}`,
            comment: submitData.customer.note || '',
            cart: {
                products: (cart || []).map(x => ({
                    catalogKey: x.item.key,
                    quantity: x.qty,
                    inputAttributes: {
                        motor: {
                            value: x.item.motor
                        },
                        type: {
                            value: x.item.type
                        }
                    }
                }))
            },
            contact: submitData.customer
        },
        form,
      };

      const cpqPrefix =   state.partner ? 'partner-' : '';
      const data = await salesqueze.createDocument(cpqPrefix + (process.env.serviceKey || 'cpq'), body);

      // await commit('setCart', {data})
      await commit('removeCart');
      await commit('removeForm');
    },
    setEditingIndex({commit}, idx) {
        commit('setEditingIndex', idx);
    },
    unsetEditingIndex({commit}) {
        commit('unsetEditingIndex');
    },
    async setProducts({commit}) {
      const products = await getProducts();
      commit('setProducts', products);
    },
    async setPartner({commit}) {
        const partner = await getPartner();
        console.log(partner);
        commit('setPartner', partner);
    }
}
export const mutations = {
    setCartItem: (state, data) => {
      if (data.idx !== null && data.idx !== undefined) {
        state.cartItems[data.idx] = data.item;
      } else {
        state.cartItems.push(data.item);
      }
      localStorage.setItem('cart', JSON.stringify(state.cartItems))
    },
    setFormItem: (state, item) => {
      state.formData = getFormFromLocalStorage();
      state.formData[item.key] = item;
      localStorage.setItem('form', JSON.stringify(state.formData))
    },
    setCart: (state, cart) => {
        state.cartItems = cart;
        localStorage.setItem('cart', JSON.stringify(state.cartItems))
    },
    setConfiguration: (state, configuration) => state.configuration = configuration,
    removeCartItem: (state, idx) => {
      if (state.cartItems.length > 1) {
        state.cartItems.splice(
            idx,
            1
        )
      } else {
        state.cartItems = [];
      }
      localStorage.setItem('cart', JSON.stringify(state.cartItems))
    },
    removeCart: (state) => {
      state.cartItems = [];
      localStorage.setItem('cart', JSON.stringify(state.cartItems));
    },
    removeForm: (state) => {
      state.form = {};
      localStorage.setItem('form', JSON.stringify(state.form));
    },
    removeConfiguration: (state) => (state.configuration = {}),
    setEditingIndex: (state, idx) => {
      state.editingIndex = idx;
      localStorage.setItem('editingIndex', idx);
    },
    unsetEditingIndex: (state) => {
      state.editingIndex = null;
      localStorage.removeItem('editingIndex');
    },
    setProducts: (state, products) => {
      state.products = products;
    },
    setPartner: (state, partner) => {
      state.partner = partner;
    }
}
